























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import Transaction from '@/models/Transaction';

@Component
export default class TransactionsDataTable extends Vue {
  @Prop({ default: [] }) items!: Transaction[];

  formatDate(dateString: string) {
    return moment(dateString).format('MMM D, YYYY');
  }

  formatMoney(money: string) {
    return `$${money}`;
  }
}
